'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';
import { type FC, memo } from 'react';
import { useUserStore } from '@/entities/User/store/userStoreProvider';
import useBreakpoints from '@/hooks/useBreakpoints';
import { Button } from '@/shared/components/Button';
import { Modal } from '@/utils/antd-imports';
import { formatNumber } from '@/utils/helpers/formatNumber';
import type { TReward } from '../../types';
import { formatReward } from './formatRevard';
interface RewardModalModalProps {
  onClose: () => void;
  reward?: TReward;
  isOpen?: boolean;
}
const RewardModal: FC<RewardModalModalProps> = t0 => {
  const $ = _c(101);
  const {
    reward,
    onClose,
    isOpen
  } = t0;
  const {
    lg
  } = useBreakpoints();
  const user = useUserStore(_temp);
  const locale = useLocale();
  const t = useTranslations("LeaderBoard.RewardModal");
  let t1;
  if ($[0] !== lg) {
    t1 = () => {
      if (lg) {
        return "560px";
      }
      return "300px";
    };
    $[0] = lg;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const calcWidth = t1;
  if (!reward) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <></>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let T0;
  let decimal;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t20;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== calcWidth || $[4] !== isOpen || $[5] !== lg || $[6] !== onClose || $[7] !== reward.place || $[8] !== reward.poe || $[9] !== t) {
    const {
      integer,
      decimal: t21
    } = formatReward(reward.poe);
    decimal = t21;
    T0 = Modal;
    t10 = isOpen;
    t11 = true;
    t12 = false;
    t13 = onClose;
    t14 = true;
    t15 = null;
    t16 = calcWidth();
    t17 = "[&_.ant-modal-content]:!bg-transparent";
    const t22 = lg ? "703px" : "508px";
    if ($[31] !== t22) {
      t18 = {
        body: {
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          minHeight: "auto",
          height: t22,
          background: "#1E1E2A",
          backdropFilter: "blur(36.85px)",
          borderRadius: "24px"
        }
      };
      $[31] = t22;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    const t23 = `absolute z-10 ${lg ? "right-[16px] top-[16px]" : "right-[12px] top-[12px]"}  flex items-center justify-center rounded-full border border-[#E9ECF033] p-2 transition-colors hover:bg-white/10`;
    let t24;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <Image src="/icons/close-default.svg" width={12} height={12} alt="Close" />;
      $[33] = t24;
    } else {
      t24 = $[33];
    }
    if ($[34] !== onClose || $[35] !== t23) {
      t19 = <button onClick={onClose} className={t23}>{t24}</button>;
      $[34] = onClose;
      $[35] = t23;
      $[36] = t19;
    } else {
      t19 = $[36];
    }
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <Image src="/images/leaderboard/modal_img.png" alt="check" width={560} height={480} className="z-0 translate-y-6 scale-125 tablet:translate-y-0 tablet:scale-100 " />;
      $[37] = t20;
    } else {
      t20 = $[37];
    }
    t7 = " z-10 -mt-9 flex flex-auto flex-col items-center justify-start gap-3 px-8 pb-8 lg:gap-4";
    let t25;
    if ($[38] !== t) {
      t25 = t("Congratulations");
      $[38] = t;
      $[39] = t25;
    } else {
      t25 = $[39];
    }
    if ($[40] !== t25) {
      t8 = <div className="flex w-full flex-col items-center gap-5 text-center text-[#E9ECF0] lg:gap-6"><h2 className="w-full  text-[24px] font-bold leading-[1.15] text-[#E9ECF0] tablet:text-[28px] lg:text-[36px]">{t25}</h2></div>;
      $[40] = t25;
      $[41] = t8;
    } else {
      t8 = $[41];
    }
    let t26;
    if ($[42] !== reward.place || $[43] !== t) {
      t26 = t("Description", {
        place: reward.place
      });
      $[42] = reward.place;
      $[43] = t;
      $[44] = t26;
    } else {
      t26 = $[44];
    }
    if ($[45] !== t26) {
      t9 = <div className="mt-1 flex w-full flex-col items-center gap-3 tablet:mt-0 lg:gap-4"><div className="w-full text-center  text-base font-medium text-[#FFFFFFCC] lg:text-[20px] ">{t26}</div></div>;
      $[45] = t26;
      $[46] = t9;
    } else {
      t9 = $[46];
    }
    t5 = "flex items-center gap-3 py-2 tablet:py-3";
    const t27 = lg ? 48 : 36;
    const t28 = lg ? 48 : 36;
    if ($[47] !== t27 || $[48] !== t28) {
      t6 = <Image src="/images/crystals.png" alt="check" width={t27} height={t28} />;
      $[47] = t27;
      $[48] = t28;
      $[49] = t6;
    } else {
      t6 = $[49];
    }
    t4 = "flex w-full  items-end tablet:w-fit ";
    t2 = "text-[36px] font-bold leading-[1] text-[#E9ECF0] tablet:text-[48px]";
    t3 = formatNumber(integer);
    $[3] = calcWidth;
    $[4] = isOpen;
    $[5] = lg;
    $[6] = onClose;
    $[7] = reward.place;
    $[8] = reward.poe;
    $[9] = t;
    $[10] = T0;
    $[11] = decimal;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
    $[22] = t2;
    $[23] = t20;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    T0 = $[10];
    decimal = $[11];
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t14 = $[16];
    t15 = $[17];
    t16 = $[18];
    t17 = $[19];
    t18 = $[20];
    t19 = $[21];
    t2 = $[22];
    t20 = $[23];
    t3 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
  }
  let t21;
  if ($[50] !== t2 || $[51] !== t3) {
    t21 = <span className={t2}>{t3}</span>;
    $[50] = t2;
    $[51] = t3;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== decimal) {
    t22 = decimal && <span className="text-[24px] font-bold leading-[1] text-[#E9ECF0] tablet:text-hero">.{decimal}</span>;
    $[53] = decimal;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t21 || $[56] !== t22 || $[57] !== t4) {
    t23 = <div className={t4}>{t21}{t22}</div>;
    $[55] = t21;
    $[56] = t22;
    $[57] = t4;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t23 || $[60] !== t5 || $[61] !== t6) {
    t24 = <div className={t5}>{t6}{t23}</div>;
    $[59] = t23;
    $[60] = t5;
    $[61] = t6;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  const t25 = user ? `/${locale}/earn` : `/${locale}/auth`;
  let t26;
  if ($[63] !== t) {
    t26 = t("DoMoreToGetMore");
    $[63] = t;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== onClose || $[66] !== t26) {
    t27 = <Button variant="white" size="md_a" textClassName="font-semibold!  leading-[22px] !text-[17px] lg:!text-[19px]" className="h-[60px] w-full grow" onClick={onClose} contentClassName="justify-center w-full text-wrap font-semibold truncate">{t26}</Button>;
    $[65] = onClose;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== t25 || $[69] !== t27) {
    t28 = <Link href={t25} className="w-full ">{t27}</Link>;
    $[68] = t25;
    $[69] = t27;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  const t29 = user ? `/${locale}/settings/my-wallet` : `/${locale}/auth`;
  let t30;
  if ($[71] !== t) {
    t30 = t("ClaimReward");
    $[71] = t;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  let t31;
  if ($[73] !== t30) {
    t31 = <span className="text-sm font-medium  pre-lg:text-[20px]">{t30}</span>;
    $[73] = t30;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== t29 || $[76] !== t31) {
    t32 = <Link href={t29} className=" text-[#707070CC] hover:text-[#E9ECF0] ">{t31}</Link>;
    $[75] = t29;
    $[76] = t31;
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== t28 || $[79] !== t32) {
    t33 = <div className="mt-4 flex w-full flex-col items-center justify-center gap-6 tablet:gap-3">{t28}{t32}</div>;
    $[78] = t28;
    $[79] = t32;
    $[80] = t33;
  } else {
    t33 = $[80];
  }
  let t34;
  if ($[81] !== t24 || $[82] !== t33 || $[83] !== t7 || $[84] !== t8 || $[85] !== t9) {
    t34 = <div className={t7}>{t8}{t9}{t24}{t33}</div>;
    $[81] = t24;
    $[82] = t33;
    $[83] = t7;
    $[84] = t8;
    $[85] = t9;
    $[86] = t34;
  } else {
    t34 = $[86];
  }
  let t35;
  if ($[87] !== T0 || $[88] !== t10 || $[89] !== t11 || $[90] !== t12 || $[91] !== t13 || $[92] !== t14 || $[93] !== t15 || $[94] !== t16 || $[95] !== t17 || $[96] !== t18 || $[97] !== t19 || $[98] !== t20 || $[99] !== t34) {
    t35 = <T0 open={t10} centered={t11} closable={t12} onCancel={t13} destroyOnHidden={t14} footer={t15} width={t16} className={t17} styles={t18}>{t19}{t20}{t34}</T0>;
    $[87] = T0;
    $[88] = t10;
    $[89] = t11;
    $[90] = t12;
    $[91] = t13;
    $[92] = t14;
    $[93] = t15;
    $[94] = t16;
    $[95] = t17;
    $[96] = t18;
    $[97] = t19;
    $[98] = t20;
    $[99] = t34;
    $[100] = t35;
  } else {
    t35 = $[100];
  }
  return t35;
};
export default memo(RewardModal);
function _temp(state) {
  return state.user;
}